import styled from 'styled-components';

export const Separator = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;

  &:before,
  &:after {
    content: '';
    flex: 1 1;
    border-bottom: 1px solid var(--grey-300);
    margin: auto;
  }

  & span {
    padding-inline: var(--spacing-large);
    font-size: var(--font-size-text-md);
    font-weight: var(--font-weight-semibold);
    line-height: 24px;
    color: var(--grey-500);
    text-transform: uppercase;
  }
`;
